import { Breadcrumbs } from '@components/Breadcrumbs'

import { Header, Hexagon, Wrapper, Content } from './styles'

export function HeaderSection({ title, image, marginTop = '208px' }) {
  return (
    <Wrapper>
      <Content zIndex="1">
        <Breadcrumbs marginTop="10px" textColor="black" />
        <Header as="h1" className="header-section-title" marginTop={marginTop}>
          {title}
        </Header>
      </Content>
      <Hexagon />
      {image}
    </Wrapper>
  )
}
